const EditorIcons = [
  {
    name: 'format-icon',
    icon: '<svg width="36" height="24" viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 5C15.5523 5 16 5.44772 16 6C16 6.55228 15.5523 7 15 7H11V18C11 18.5523 10.5523 19 10 19C9.44772 19 9 18.5523 9 18V7H5C4.44772 7 4 6.55228 4 6C4 5.44772 4.44772 5 5 5H15Z" /><rect x="21" y="9.41418" width="2" height="9" rx="1" transform="rotate(-45 21 9.41418)" /><rect x="32.364" y="8" width="2" height="9" rx="1" transform="rotate(45 32.364 8)" /></svg>'
  }
];

export default EditorIcons;